import { DateTime } from "luxon"
import React from "react"
import { CampProps, ReservationProps } from "~/interfaces"
import createMarkup from "~/utils/createMarkup"

interface ComponentProps {
  reservation: ReservationProps
  camp: CampProps
}

const SignatureForPrinting = ({ reservation, camp }: ComponentProps) => {
  const camper = reservation?.camper
  const { kid_campers = 0, passengers = 0 } = reservation || {}
  const numberOfGuest = kid_campers + passengers

  const formatReservationDate = (date: string) => {
    const processedDate = DateTime.fromISO(date, {
      zone: camp.timezone,
    })

    if (!processedDate.isValid) {
      return DateTime.fromJSDate(new Date(date)).toFormat("MMMM dd, yyyy HH:mm")
    }

    return processedDate.toFormat("MMMM dd, yyyy HH:mm")
  }

  return (
    <div className="p-8 border border-gray-300 rounded-lg shadow-md max-w-3xl mx-auto">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold">
          {camper?.first_name} {camper?.last_name}
        </h1>
        {!!numberOfGuest && <p className="text-xl text-gray-700 mt-2">Number of guests: {numberOfGuest}</p>}
        <p className="text-xl text-gray-700 mt-1">
          Reservation dates: {formatReservationDate(reservation.start_date)} -{" "}
          {formatReservationDate(reservation.end_date)}
        </p>
      </div>

      {!!camp.rules?.length && (
        <>
          <div className="w-full h-0.5 bg-gray-400 my-6"></div>
          <div>
            <h2 className="text-2xl font-semibold mb-4">Rules</h2>
            <div
              className="rules-container html-editor-container text-gray-800 leading-relaxed"
              dangerouslySetInnerHTML={createMarkup(camp.rules)}
            />
          </div>
        </>
      )}

      <div className="w-full h-0.5 bg-gray-400 my-6"></div>

      <div className="text-center" style={{ pageBreakInside: "avoid" }}>
        {reservation.tos_signature && (
          <div className="mb-4">
            <img src={reservation.tos_signature} alt="Signature" className="inline-block border max-w-xs mt-2" />
          </div>
        )}
        {reservation?.tos_agreed_at && (
          <p className="text-sm text-gray-600">
            Signed on: {DateTime.fromISO(reservation?.tos_agreed_at).toFormat("MMMM dd, yyyy 'at' hh:mm a")}
          </p>
        )}
      </div>
    </div>
  )
}

export default SignatureForPrinting
